import api from './api';
import API_ROUTES from './apiRoutes';

const coachStaffService = {
  // Get all staff members for the logged-in coach
  getStaff: async () => {
    const response = await api.get(API_ROUTES.COACH.STAFF);
    return response.data;
  },

  // Add a new staff member (jobTitle is fixed to "coach")
  addStaff: async ({ firstName, lastName, email }) => {
    const response = await api.post(API_ROUTES.COACH.ADD_STAFF, {
      firstName,
      lastName,
      email,
      jobTitle: 'coach',
    });
    return response.data;
  },
};

export default coachStaffService;
